import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Typography } from '@components/Typography';
import StatusDot from '@components/StatusDot';
import { useCopyToClipboard, useThrottle, useTranslation } from '@hooks';

const Card = styled('div')({
    border: '1px solid var(--divider)',
    borderRadius: 8,
    padding: '12px 16px',
    margin: '8px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
});

const Row = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
});

const Label = styled(Typography)({
    color: 'var(--text-secondary)',
    minWidth: 48,
});

const Value = styled(Typography)({
    fontFamily: 'monospace',
    fontSize: 13,
    wordBreak: 'break-all',
    flex: 1,
});

const StatusValue = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: 1,
});

const DnsRecordCard = ({ type = 'CNAME', name, value, status, statusLabel }) => {
    const { t } = useTranslation();
    const { onCopy } = useCopyToClipboard();
    const [onCopyClick] = useThrottle(text => onCopy(text), 1000);

    return (
        <Card>
            <Row>
                <Label variant="caption">{t('DnsRecordCard.type')}</Label>
                <Value variant="body2">{type}</Value>
                <div style={{ width: 32 }} />
            </Row>
            <Row>
                <Label variant="caption">{t('DnsRecordCard.name')}</Label>
                <Value variant="body2">{name}</Value>
                <IconButton size="small" onClick={() => onCopyClick(name)}>
                    <ContentCopyIcon sx={{ fontSize: 16, color: 'var(--text-secondary)' }} />
                </IconButton>
            </Row>
            <Row>
                <Label variant="caption">{t('DnsRecordCard.value')}</Label>
                <Value variant="body2">{value}</Value>
                <IconButton size="small" onClick={() => onCopyClick(value)}>
                    <ContentCopyIcon sx={{ fontSize: 16, color: 'var(--text-secondary)' }} />
                </IconButton>
            </Row>
            {statusLabel ? (
                <Row>
                    <Label variant="caption">{t('DnsRecordCard.status')}</Label>
                    <StatusValue>
                        <StatusDot status={status} />
                        <Typography variant="body2">{statusLabel}</Typography>
                    </StatusValue>
                    <div style={{ width: 32 }} />
                </Row>
            ) : null}
        </Card>
    );
};

export default DnsRecordCard;
